import script from "./TheDuvidas.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDuvidas.vue?vue&type=script&setup=true&lang=js"

import "./TheDuvidas.vue?vue&type=style&index=0&id=a7a12dc4&lang=scss"

const __exports__ = script;

export default __exports__